export { default } from "./SocialSharing";
